import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';

import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/modules/shared/services/util.service';
@Injectable({
  providedIn: 'root'
})
export class CouponsService {

  constructor(
    private _router: Router,
    private _utilService: UtilService,
    private _httpClient: HttpClient
  ) { }

  // Get products
  getProducts(token: string, providerType : string, providerId: string, page: any, searchText: string){
    const URL = environment.apiUrl + 'dashboard/products';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqParams = new HttpParams()
      .set('provider_type', providerType)
      .set('provider_id', providerId)
      .set('page', page)
      .set('search_text', searchText);

    return this._httpClient.get<any>(URL, {headers: reqHeaders, params: reqParams});
  }

  // Get coupon types
  getCouponTypes(token: string){
    const URL = environment.apiUrl + 'dashboard/couponTypes';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);

    return this._httpClient.get<any>(URL, {headers: reqHeaders});
  }

  // Get retailer list
  getRetailers(token: string, body: any){
    const URL = environment.apiUrl + 'dashboard/retailers';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqBody = JSON.stringify(body);

    return this._httpClient.post<any>(URL, reqBody, {headers: reqHeaders});
  }

  // Create coupons
  createCoupons(token: string, body: any){
    const URL = environment.apiUrl + 'dashboard/createCoupons';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqBody = JSON.stringify(body);

    return this._httpClient.post<any>(URL, reqBody, {headers: reqHeaders});
  }

  // Get coupons
  getCoupons(token: string, providerType : string, providerId: string, mfgId: string, brandId: string, retailerId: string, storeId: string, couponSource: string, couponStatus: string, page: any){
    const URL = environment.apiUrl + 'dashboard/coupons';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqParams = new HttpParams()
      .set('provider_type', providerType)
      .set('provider_id', providerId)
      .set('mfg_id', mfgId)
      .set('brand_id', brandId)
      .set('retailer_id', retailerId)
      .set('store_id', storeId)
      .set('coupon_source', couponSource)
      .set('coupon_status', couponStatus)
      .set('page', page);

    return this._httpClient.get<any>(URL, {headers: reqHeaders, params: reqParams});
  }

}
